import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./CallCareSupport.scss";
import {
  Table,
  Button,
  Space,
  Select,
  DatePicker,
  TimePicker,
  Tabs,
  Tag,
  Card
} from "antd";
import Axios from "../../Helpers/Interceptors";
import { useNavigate } from "react-router-dom";
const formatDateUS = (date) => {
  return new Date(date).toLocaleDateString("en-US");
};

export default function CallCareSupport() {

  const { Option } = Select;
  const navigate = useNavigate();
  const [list, setlist] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    size: 10,
    total: 0, // You’ll get the total count of records from your API response
  });
  const handleChange = (value) => {
    console.log('Selected:', value);
  };
  const activeTab=''
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
    },
    {
      title: "Author",
      dataIndex: "author",
      key: "author",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (type) => (
        <span style={{ fontWeight: "bold", color: getTypeColor(type) }}>
          {type}
        </span>
      ),
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Critical",
      dataIndex: "critical",
      key: "critical",
      render: (critical) => (
        <span style={{ color: critical ? "red" : "green", fontWeight: "bold" }}>
          {critical ? "Yes" : "No"}
        </span>
      ),
    },
  ];
  const data = [
    {
      id: 1,
      time: "17:32",
      note: "Caller sounds panicked, possible domestic violence",
      author: "Operator A",
      type: "Observation",
      location: "Sector 12, New York",
      critical: true,
    },
    {
      id: 2,
      time: "17:34",
      note: "Police dispatched, ETA 5 mins",
      author: "Dispatcher",
      type: "Action",
      location: "Nearest Unit - NYPD Precinct 5",
      critical: false,
    },
  ];

  const getTypeColor = (type) => {
    switch (type) {
      case "Observation":
        return "blue";
      case "Action":
        return "purple";
      case "Instruction":
        return "orange";
      case "Update":
        return "teal";
      default:
        return "black";
    }
  };

  useEffect(() => {
    fetchData(pagination.page, pagination.size);
  }, []);

  const handlePaginationChange = (page, pagesize) => {
    console.log("asd", page, pagesize);
    setPagination((prev) => ({ ...prev, page: page, size: pagesize }));
    fetchData(page, pagesize);
  };

  const fetchData = async (page, size) => {
    const obj = {
      page: page,
      size: size,
    };
    try {
      const response = await Axios.get(
        `https://demo.tscti.com/api/incidents/all?page=${page}&size=${size}`
      );

      setlist([]);
      setPagination((prop) => ({
        ...prop,
        total: 0 || 0, // Set total from the response
      }));
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };

  return (
    <div
      className="signup-content2 "
      style={{ paddingLeft: "2%", paddingRight: "2%", paddingTop: "1%" ,height:'100vh'}}
    >
      {/* <div
          className="card  mb-3  p-3"
          style={{
            background:
              "rgb(130 195 65 / 69%)",
            textAlign: "left",
          }}
        >
          <h5 style={{ color: "whitesmoke" ,marginBottom:'0px'}}>Calls Care </h5>
        </div> */}

        <div className="d-flex w-100 border border-start-0 border-top-0 border-end-0 mb-2">
  <div
    // onClick={() => setActiveTab("all-tickets")}
    className={`px-4 py-3 border-end text-decoration-none ${
      activeTab === "all-tickets" ? "fw-bold text-white bg-dark" : "bg-secondary text-light"
    }`}
    style={{
      flex: 1,
      textAlign: "center",
      fontFamily: "Poppins, sans-serif",
      fontWeight: "700",
      cursor: "pointer",
    }}
  >
    Recorded calls
  </div>



  <div
    // onClick={() => setActiveTab("resolved-tickets")}
    className={`px-4 py-3 text-decoration-none ${
      activeTab === "resolved-tickets" ? "fw-bold text-white bg-dark" : "bg-secondary text-light"
    }`}
    style={{
      flex: 1,
      textAlign: "center",
      fontFamily: "Poppins, sans-serif",
      fontWeight: "700",
      cursor: "pointer",
    }}
  >
   All Calls
  </div>
</div>


      <div className="bg-gradient p-2 rounded filter">
        <div className="row">
          <div className="col-md-4 col-lg-4">
            <label className="label-heading1">Search</label>
            <input
              className={`form-input
                          `}
              name="ticketNumber"
              id="ticketNumber"
              placeholder="Search Here*"
              autoComplete="new-password"
            />
          </div>
          {/* <div className="col-md-2 col-lg-2">
            <label className="label-heading1">Ticket Type</label>
            <input
              className={`form-input`}
              name="request_type"
              id="request_type"
              placeholder="Ticket Type*"
              autoComplete="new-password"
            />
          </div>

          <div className="col-md-2 col-lg-2">
            <label className="label-heading1">Status</label>
            <Select
              style={{
                width: "100%",
                height: '65%',
                background: "#15212d",
                borderColor: "rgb(223, 223, 223)",
              }}
              placeholder="Status*"
              options={[
                { value: "Reported", label: "Reported" },
                { value: "In Progress", label: "In Progress" },
                {
                  value: "Assign To DPT",
                  label: "Assign to DPT",
                },
                {
                  value: "Resolved",
                  label: "Resolved",
                },
              ]}
            />
          </div>

          <div className="col-md-2 col-lg-2">
          <label className="label-heading1">Select Agent</label>
          <Select
            style={{
              width: "100%",
              height: '65%',
              maxHeight: '65%',
              background: "#15212d",
              borderColor: "rgb(223, 223, 223)",
            }}
      mode="multiple"
      allowClear

      placeholder="Select options"
      onChange={handleChange}
    >
      <Option value="apple">Apple</Option>
      <Option value="banana">Banana</Option>
      <Option value="cherry">Cherry</Option>
      <Option value="grape">Grape</Option>
    </Select>
          </div> */}

          <div className="col-md-3 col-lg-3">
          <div className="filter-button">
          <button
            className="btn btn-style btn-save"
            style={{ background: "rgb(130 195 65 / 69%)", color: "whitesmoke" }}
          >
            <i className="fas fa-search" style={{ marginRight: "8px" }}></i> Search
          </button>

          <button
            className="btn btn-style btn-cancel"
            style={{ background: "#F44336", color: "whitesmoke" }}
            onClick={() => navigate("/dashboard")}
          >
            <i className="fas fa-times" style={{ marginRight: "8px" }}></i>{" "}
            Cancel
          </button>

          </div>
          </div>
        </div>



      </div>

      <div className="bg-gradient p-2 rounded" style={{ position: "relative" }}>
        <Table
          dataSource={data}
          columns={columns}
          scroll={{ y: 350 }}
          rowClassName={() => "custom-row"}
          pagination={{
            showSizeChanger: true,
            onChange: handlePaginationChange,

            current: pagination.page,
            pageSize: pagination.size,

            total: pagination.total,

            showTotal: (total, range) => (
              <span style={{ color: "whitesmoke" }}>
                Total {total} records, showing {range[0]} to {range[1]}
              </span>
            ),
          }}
        />
        {/* <div
          className="table-header"
          style={{
            background: "rgb(5, 162, 179)",
          }}
        >
          <h4 style={{ fontFamily: "Myriad Pro" }}>Agent Care Tickets</h4>
        </div> */}
        ;
      </div>
    </div>
  );
}
